// import { Box, Button, Typography } from '@mui/material'
// import colors from '../../constants/colors'

// interface ISubmitCancelButtons {
//   submitHandler: () => void
//   cancelHandler: () => void
//   submitButtonText: string | React.ReactNode
//   cancelButtonText: string | React.ReactNode
//   className?: string
// }

// const SubmitCancelButtons: React.FC<ISubmitCancelButtons> = ({
//   submitHandler,
//   cancelHandler,
//   submitButtonText,
//   cancelButtonText,
//   className = '',
// }) => {
//   return (
//     <Box
//       className={`t-save-cancel-btns ${className}`}
//       sx={{ position: 'fixed', bottom: '2rem', right: '2rem', minWidth: '4rem' }}
//     >
//       <Button
//         sx={{
//           backgroundColor: colors.GREEN,
//           display: 'flex',
//           flexDirection: 'column',
//           marginBottom: '1rem',
//           width: '100%',
//           padding: '15px 30px',
//           maxWidth: '12rem',
//         }}
//         onClick={submitHandler}
//       >
//         <Typography color={colors.WHITE} variant='bodyBold' style={{ whiteSpace: 'pre-line' }}>
//           {submitButtonText}
//         </Typography>
//       </Button>
//       <Button
//         variant='outlined'
//         sx={{ width: '100%', backgroundColor: 'white' }}
//         onClick={cancelHandler}
//       >
//         <Typography color={colors.BLACK} variant='bodyRegular'>
//           {cancelButtonText}
//         </Typography>
//       </Button>
//     </Box>
//   )
// }

// export default SubmitCancelButtons

import { Box, Button, Typography } from '@mui/material'
import colors from '../../constants/colors'

interface ISubmitCancelButtons {
  submitHandler: () => void
  cancelHandler: () => void
  submitButtonText: string | React.ReactNode
  cancelButtonText: string | React.ReactNode
  className?: string
}

const SubmitCancelButtons: React.FC<ISubmitCancelButtons> = ({
  submitHandler,
  cancelHandler,
  submitButtonText,
  cancelButtonText,
  className = '',
}) => {
  return (
    <Box
      className={`t-save-cancel-btns ${className}`}
      sx={{ position: 'fixed', bottom: '2rem', right: '2rem', minWidth: '4rem' }}
    >
      <Button
        sx={{
          backgroundColor: colors.GREEN,
          display: 'flex',
          flexDirection: 'column',
          marginBottom: '1rem',
          width: '100%',
          padding: '15px 30px',
          maxWidth: '12rem',
          transition: 'background-color 0.3s',
          '&:hover': {
            backgroundColor: '#087f23', // slightly darker than colors.GREEN
          },
        }}
        onClick={submitHandler}
      >
        <Typography color={colors.WHITE} variant='bodyBold' style={{ whiteSpace: 'pre-line' }}>
          {submitButtonText}
        </Typography>
      </Button>

      <Button
        variant='outlined'
        sx={{
          width: '100%',
          backgroundColor: 'white',
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
        }}
        onClick={cancelHandler}
      >
        <Typography color={colors.BLACK} variant='bodyRegular'>
          {cancelButtonText}
        </Typography>
      </Button>
    </Box>
  )
}

export default SubmitCancelButtons
